<template>
  <div class="reports-page">
    <PageHeader
      :title="title"
      :subtitle="subtitle"
      :actions="actions"
      @action="$emit('action', $event)"
    />

    <div class="reports-content">
      <slot name="content">
        <slot name="income-tabs"></slot>
        <slot name="report-tabs"></slot>
        <slot name="metrics"></slot>
        <slot name="toolbar"></slot>
        <slot name="chart"></slot>
        <slot name="table"></slot>
      </slot>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/common/PageHeader.vue';

export default {
  name: 'ReportsPageShell',
  components: {
    PageHeader,
  },
  props: {
    title: {
      type: String,
      default: 'Reportes',
    },
    subtitle: {
      type: String,
      default: '',
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['action'],
};
</script>
